
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, Users, FileText, BookOpen, Star, Percent,
  MessageSquare, Mail, ShieldCheck, Award, BarChart3,
  Settings
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { ScrollArea } from '@/components/ui/scroll-area';
import { DrawerHeader, DrawerTitle, DrawerFooter } from '@/components/ui/drawer';

interface MobileMenuProps {
  onClose: () => void;
}

export function MobileMenu({ onClose }: MobileMenuProps) {
  const location = useLocation();
  
  const isActive = (path: string) => {
    if (path === '/dashboard') {
      return location.pathname === '/' || location.pathname === '/dashboard';
    }
    return location.pathname.startsWith(path);
  };

  const MenuLink = ({ href, icon, children }: { href: string; icon: React.ReactNode; children: React.ReactNode }) => (
    <Link
      to={href}
      className={cn(
        "flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-all",
        isActive(href)
          ? "bg-primary text-primary-foreground"
          : "text-muted-foreground hover:text-foreground hover:bg-accent"
      )}
      onClick={onClose}
    >
      {icon}
      <span>{children}</span>
    </Link>
  );

  return (
    <div className="px-6 py-4">
      <DrawerHeader className="pb-2">
        <DrawerTitle className="text-lg">Navigation Menu</DrawerTitle>
      </DrawerHeader>
      
      <ScrollArea className="h-[calc(75vh-5rem)]">
        <div className="space-y-6">
          <div>
            <h2 className="mb-2 px-3 text-xs font-semibold text-muted-foreground">General</h2>
            <div className="space-y-1">
              <MenuLink href="/dashboard" icon={<Home className="h-4 w-4" />}>Dashboard</MenuLink>
              <MenuLink href="/users" icon={<Users className="h-4 w-4" />}>Users</MenuLink>
              <MenuLink href="/documents" icon={<FileText className="h-4 w-4" />}>Documents</MenuLink>
              <MenuLink href="/courses" icon={<BookOpen className="h-4 w-4" />}>Courses</MenuLink>
              <MenuLink href="/reviews" icon={<Star className="h-4 w-4" />}>Reviews</MenuLink>
              <MenuLink href="/discounts" icon={<Percent className="h-4 w-4" />}>Discounts</MenuLink>
              <MenuLink href="/chatlogs" icon={<MessageSquare className="h-4 w-4" />}>Chat Logs</MenuLink>
              <MenuLink href="/email-templates" icon={<Mail className="h-4 w-4" />}>Email Templates</MenuLink>
            </div>
          </div>
          
          <div>
            <h2 className="mb-2 px-3 text-xs font-semibold text-muted-foreground">Compliance</h2>
            <div className="space-y-1">
              <MenuLink href="/compliance" icon={<ShieldCheck className="h-4 w-4" />}>Compliance Dashboard</MenuLink>
              <MenuLink href="/certificates" icon={<Award className="h-4 w-4" />}>Certificates</MenuLink>
              <MenuLink href="/certificates/templates" icon={<FileText className="h-4 w-4" />}>Templates</MenuLink>
              <MenuLink href="/certificates/reports" icon={<BarChart3 className="h-4 w-4" />}>Reports</MenuLink>
            </div>
          </div>
          
          <div>
            <h2 className="mb-2 px-3 text-xs font-semibold text-muted-foreground">Settings</h2>
            <div className="space-y-1">
              <MenuLink href="/settings" icon={<Settings className="h-4 w-4" />}>Settings</MenuLink>
            </div>
          </div>
        </div>
      </ScrollArea>
      
      <DrawerFooter className="mt-4 pb-8">
        <p className="text-xs text-center text-muted-foreground">DriveCourses Admin © 2025</p>
      </DrawerFooter>
    </div>
  );
}
